import { format } from 'date-fns'
import { getDatePeriod } from '~features/events'
import type { MonthData } from '../../types/types'

export const createMonthData = (date: Date): MonthData => ({
	id: format(date, 'yyyy-MM'),
	date,
	period: getDatePeriod(date),
	isLoaded: false
})
